/* eslint-disable class-methods-use-this */
import nes from "nes";
import store from "@/store";

class SocketConnection {
  nes;

  client;

  cb;

  isConnected = false;

  address;

  constructor() {
    this.nes = nes;
    this.init();
  }

  async init() {
    // try {
    //   if (!config.ws.url) {
    //     return;
    //   }
    //   this.client = new this.nes.Client(config.ws.url);
    //   await this.client.connect({
    //     auth: {
    //       headers: { Authorization: config.getWSAuth() },
    //     },
    //   });

    //   this.client.onDisconnect = this.handleDisconnect;
    //   this.client.onError = this.handleError;
    //   this.isConnected = true;
    // } catch (e) {
    // }
  }

  handleDisconnect = (willReconnect, log) => {
    if (!willReconnect) {
      this.init();
    }
  };

  handleError = (err) => {
    this.init();
  };

  paymentHandler(data) {
    store.commit("user/setSocketResponse", data);
  }

  subscribe(address) {
    this.address = address;
    this.client.subscribe(`/qr-status/${address}`, this.paymentHandler);
  }

  connected() {
    return this.isConnected;
  }

  onEventReceived(func) {
    this.cb = func;
  }

  async disconnect() {
    await this.client.unsubscribe(`/qr-status/${this.address}`);
    await this.client.disconnect();
  }
}

const websocket = new SocketConnection();
export default websocket;
